"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var factory_1 = require("../../factory");
var browser_1 = require("./browser");
function getSystemDetails() {
    return new Promise(function (resolve) {
        var browser = (0, browser_1.getBrowser)();
        resolve({
            'platform': window.navigator.platform,
            'cookieEnabled': window.navigator.cookieEnabled,
            'productSub': navigator.productSub,
            'product': navigator.product,
            'useragent': navigator.userAgent,
            'browser': { 'name': browser.name, 'version': browser.version }
        });
    });
}
(0, factory_1.includeComponent)('system', getSystemDetails);
//# sourceMappingURL=system.js.map